import block from './block.json';

export const sliderThemeAttributes = {
	navigation: {
		color: '@tokens.colors.neutral-900.value',
		button: {
			width: [18, 22],
		},
	},
	pagination: {
		bullets: {
			backgroundColor: '@tokens.colors.neutral-000.value',
			width: 6,
			height: 6,
			margin: {
				left: [3, 3],
				right: [3, 3],
			},
		},
		fraction: {
			color: '@tokens.variants.default.titleColor',
			typography: '@tokens.typographies.caption',
			textAlignment: 'left',
		},
	},
	states: {
		hover: {},
	},
};

export const SliderThemeControls: ThemeControlsType = {
	// What's displayed
	title: block.title,

	// Unique string/id of the block (= the key used in theme.json)
	slug: block.slug,

	// styling attributes available for this block
	// ...the same way we define attributes for a gutenberg block
	attributes: sliderThemeAttributes,

	// this renders in the Customizer panel
	// ...the same way "<InspectorControls />" renders in the gutenberg panel
	edit: () => null,
};
